import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { extensionInstalledCreator } from '../creators/device';

export function useExtensionInstalled() {
  const dispatch = useDispatch();

  const checkedExtensionInstalled = useSelector(
    state => state.device.checked_extension_installed
  );
  const extensionInstalled = useSelector(
    state => state.device.extension_installed
  );

  useEffect(() => {
    if (checkedExtensionInstalled || extensionInstalled) {
      return;
    }

    dispatch(extensionInstalledCreator());
  }, [checkedExtensionInstalled, dispatch, extensionInstalled]);

  return extensionInstalled;
}
